import * as THREE from "three";

import Experience from "../Experience.js";

export default class Environment {
  constructor() {
    this.experience = new Experience();
    this.scene = this.experience.scene;

    this.setAmbientLight();
    this.setDirectionalLight();
    this.setFillLight();
  }

  setAmbientLight() {
    this.ambientLight = new THREE.AmbientLight("#ffffff", 4.0);
    this.scene.add(this.ambientLight);
  }

  setDirectionalLight() {
    this.directionalLight = new THREE.DirectionalLight("#ffffff", 8.0);
    this.directionalLight.position.set(0, 5, 5);
    this.directionalLight.castShadow = true;
    this.scene.add(this.directionalLight);
  }

  setFillLight() {
    this.fillLight = new THREE.DirectionalLight("#ffffff", 4.0);
    this.fillLight.position.set(5, 0, 0); // Right side fill light
    this.fillLight.castShadow = true;
    this.scene.add(this.fillLight);
  }

  dispose() {
    // Remove lights from scene
    if (this.ambientLight) {
      this.scene.remove(this.ambientLight);
      this.ambientLight.dispose();
    }
    if (this.directionalLight) {
      this.scene.remove(this.directionalLight);
      this.directionalLight.dispose();
    }
    if (this.fillLight) {
      this.scene.remove(this.fillLight);
      this.fillLight.dispose();
    }
  }
}
